import React from "react";
import { FlechBtn } from "../../../assets/icons/FlechBtn";
import img from "../../../assets/images/ques1.png";
import img1 from "../../../assets/images/ques2.png";
import img2 from "../../../assets/images/ques3.png";
import "./index.scss";
export const Question = () => {
  return (
    <div className="question">
      <div className="question-container mt-5 mb-5">
        <div className="row ms-0 justify-content-center gx-0 w-100 align-items-center mt-5">
          <div className="col-12 col-md-5 mx-auto">
            <img src={img} alt="img" className="img-fluid" />{" "}
          </div>
          <div className="col-12 col-md-7 mx-auto">
            <div className="question-title">Vous êtes un particulier ?</div>
            <div className="question-text mt-3 mb-3">
              Améliorez votre confort thermique, réalisez des économies
              d’énergie et valorisez votre patrimoine.
            </div>

            <div>
              {" "}
              <a class="btn-slide" href="/contact">
                <span class="circle">
                  <FlechBtn />
                </span>

                <span class="title">Demander un devis gratuit</span>
                <span class="title title-hover">Demander un devis gratuit</span>
              </a>{" "}
            </div>
          </div>
        </div>
        <div className="row ms-0 justify-content-center gx-0 w-100 align-items-center mt-5 flex-column-reverse-mobile">
          <div className="col-12 col-md-7 mx-auto">
            <div className="question-title">
              Vous représentez une copropriété ?
            </div>
            <div className="question-text mb-3 mt-3">
              Confiez-nous votre ITE ou votre ravalement, avec un suivi
              technique, administratif et la tranquillité d’un chantier bien
              géré.
            </div>

            <div>
              {" "}
              <a class="btn-slide" href="/contact">
                <span class="circle">
                  <FlechBtn />
                </span>

                <span class="title">Demander un devis gratuit</span>
                <span class="title title-hover">Demander un devis gratuit</span>
              </a>{" "}
            </div>
          </div>
          <div className="col-12 col-md-5 mx-auto">
            <img src={img1} alt="img" className="img-fluid" />{" "}
          </div>
        </div>
        <div className="row ms-0 justify-content-center gx-0 w-100 align-items-center mt-5">
          <div className="col-12 col-md-5 mx-auto">
            <img src={img2} alt="img" className="img-fluid" />{" "}
          </div>
          <div className="col-12 col-md-7 mx-auto">
            <div className="question-title">Vous êtes investisseur ?</div>
            <div className="question-text mb-3 mt-3">
              Rénovation globale clé en main pour une mise en location ou
              revente rapide. Rentabilisez votre projet en toute sérénité.
            </div>

            <div>
              {" "}
              <a class="btn-slide" href="/contact">
                <span class="circle">
                  <FlechBtn />
                </span>

                <span class="title">Demander un devis gratuit</span>
                <span class="title title-hover">Demander un devis gratuit</span>
              </a>{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
